import React from 'react';
import useStyles from './styles';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
import { Alert, Typography } from '@mui/material';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { ACHPaymentOptionForm } from 'src/components/settings/ACHPaymentOptionForm';
import { propertyPayoutDetailsValidationScheme } from 'src/utils/formValidation/AddNewProperty';
export default function ModalForm(_ref) {
  let handleModalClose = _ref.handleModalClose,
    payoutData = _ref.payoutData,
    triggerReload = _ref.triggerReload;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const sendPayoutData = async _ref2 => {
    let nameOnAccount = _ref2.nameOnAccount,
      depositoryName = _ref2.depositoryName,
      routingNumber = _ref2.routingNumber,
      accountNumber = _ref2.accountNumber;
    try {
      if (nameOnAccount && depositoryName && routingNumber && accountNumber) {
        const reqData = {
          nameOnAccount,
          depositoryName,
          routingNumber,
          accountNumber,
          id: payoutData.id
        };
        const response = await store.payment.putPayoutMethodsAsync.run(reqData);
        if (!!(response !== null && response !== void 0 && response.isSuccessful)) {
          toast('success', {
            body: ['Successfully updated']
          });
        }
      }
      handleModalClose();
      triggerReload();
    } catch (e) {
      console.log('Error', e);
    }
  };
  const formik = useFormik({
    initialValues: {
      nameOnAccount: payoutData === null || payoutData === void 0 ? void 0 : payoutData.nameOnAccount,
      depositoryName: payoutData === null || payoutData === void 0 ? void 0 : payoutData.depositoryName,
      routingNumber: payoutData === null || payoutData === void 0 ? void 0 : payoutData.routingNumber,
      accountNumber: payoutData === null || payoutData === void 0 ? void 0 : payoutData.accountNumber
    },
    validationSchema: propertyPayoutDetailsValidationScheme,
    onSubmit: async values => {
      await sendPayoutData(values);
    }
  });
  return /*#__PURE__*/React.createElement("form", {
    id: 'update_property_payout_details' + payoutData.id,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.putPayoutMethodsAsync.inProgress
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.formsWrapper
  }, /*#__PURE__*/React.createElement(HelpCenterButton, {
    topic: "reimbursement"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ACHPaymentOptionForm, {
    editMode: true,
    formik: formik,
    handlePrimaryPaymentMethodChange: () => {}
  }))), /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.authorization_details')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.authorization_text'))));
}